var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGenderNeutral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8,
    d: "M1.28,23.44l.56-2.32c.32-1.2,1.04-2.08,2.24-2.48l4.32-1.44c.96-.4.96-2.24,1.04-2.8-1.12-.8-1.68-2.88-1.84-3.36-.88.32-1.84-3.84-.8-3.28.08-4.96,2.24-7.12,5.28-7.12s5.2,2.16,5.2,7.04c1.04-.56.08,3.6-.8,3.28-.24.48-.72,2.56-1.84,3.36.08.56.08,2.4,1.04,2.8l4.32,1.44c1.2.4,1.92,1.28,2.24,2.48l.56,2.32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGenderNeutral);
export default __webpack_public_path__ + "static/media/user-gender-neutral.799a2694c63e6ea954722cc6b2f99c0f.svg";
export { ForwardRef as ReactComponent };